import JSON_CONFIG from "../config.json";

export const CONFIG = {
  ORDER_SHEET_NAME: "BC_ORDRELINJER",
  PROJECT_SHEET_NAME: "INVO_DATA",
  // Urls to functions
  CREATE_ORDERS_URL: JSON_CONFIG.CREATE_ORDERS_URL,
  FETCH_ORDERS_URL: JSON_CONFIG.FETCH_ORDERS_URL,
};
